import { media } from 'common/responsive';
import styled from 'styled-components';
import Button from 'elements/Button';
import React from 'react';
import PropTypes from 'prop-types';

const DownloadButton = Button.extend`
  margin: 0;
  width: inherit;
  ${media.desktop`
    width: 100%;
  `};
`;
const DownloadAHref = styled.a`
  cursor: pointer; 
  text-decoration: inherit; 
`;

const DownloadButtonElement = (props) => {
  const { file, fileName, buttonText } = props;
  return (
    <DownloadAHref href={file} download={fileName} target="_blank" rel="noopener noreferrer">
      <DownloadButton>
        {buttonText}
      </DownloadButton>
    </DownloadAHref>
  );
};

DownloadButtonElement.propTypes = {
  file: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};


export default DownloadButtonElement;



// WEBPACK FOOTER //
// ./src/kentico-blocks/DownloadBar/DownloadButton.jsx